<!-- 监测点详细编辑图片 Canvas -->
<template>
  <modal :title="$t('device.device_location')" :visible='showDialog' @close='close' width='1000px'
         class='uk-padding-remove' append-to-body>
    <div class='pm-right' ref='pmRight' style='height: 500px; '>
      <!-- @mousedown="mousedown" @mousemove="mousemove" @mouseup="mouseup"
      @mouseleave="mouseLeave"  -->
      <div class='uk-flex height-percent-100'>
        <div class='aside'>
          <table class='uk-table uk-table-small uk-table-middle uk-text-nowrap uk-border-right'>
            <tr>
              <td>{{ $t('device.zoom') }}</td>
              <td>
                <el-slider style='width: 150px' v-model='zoomRate' :step='1' :min='-2' :max='2'
                           :format-tooltip='formatTooltip' show-stops></el-slider>
              </td>
            </tr>
            <tr>
              <td>{{ $t('public.img') }}</td>
              <td>
                <div class='uk-flex'>
                  <el-input :placeholder="$t('device.upload_carrier_img')" disabled
                            style='width: 120px; margin-right: 4px' :value='curFile.name'></el-input>
                  <el-upload :show-file-list='false' ref='upload' accept='.jpg,.png,.bmp,.jpeg'
                             :auto-upload='false' :before-upload='beforeAvatarUpload' :on-change='fileChange'
                             action='http://' :http-request='uploadImg'>
                    <div class='uk-flex'>
                      <el-button slot='trigger' class='uk-margin-remove' icon='el-icon-upload2'
                                 :title="$t('device.select_img')"></el-button>
                    </div>
                    <!-- <div slot="tip" class="el-upload__tip">{{$t('integration.only_jpg/png_files_can_be_uploaded_c__and_no_more_than_500kb')}}</div> -->
                  </el-upload>
                  <el-button icon='el-icon-upload' :title="$t('integration.confirm_upload')"
                             :disabled='!curFile.name' @click='submitUpload'></el-button>
                </div>
              </td>
            </tr>
          </table>

          <div v-if='equiList && equiList.sensorList.length'>
            <div>{{ $t('public.sensor') }}</div>
            <div>
              <div v-for='(item, index) in equiList.sensorList' :key='index'>
                <div class='uk-flex uk-flex-between uk-margin-small-top'>
                  <div>

                    <span><i v-if="item.deviceStatus !== 'undefined'"
                             :class='equiStatusConvert(item.deviceStatus).icon'
                             :title='equiStatusConvert(item.deviceStatus).title'></i></span>
                    <span><i v-if="item.isNoData !== 'undefined'"
                             :class='item.ex.length >= 1 ? isAbnormalConvert(1).icon : isAbnormalConvert(0).icon'
                             :title="item.ex.join(',') || '正常'"></i></span>
                    <span class='uk-margin-small-left' :class="{ 'higher-range': item.locate }">
                                            {{ item.carrierDeviceName }}</span>
                  </div>
                  <div>
                    <i class='el-icon-tickets cursor-pointer' :title="$t('public.details')"
                       @click='toDetail(item)'></i>
                    <i class='el-icon-location-outline cursor-pointer' :title="$t('public.location')"
                       v-show='!item.locate' @click="locate(item, 'sensor')"></i>
                    <i class='el-icon-close cursor-pointer' :title="$t('integration.cancel')"
                       v-show='item.locate' @click='cancel(item)'></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if='equiList && equiList.gatewayList.length'>
            <div class='uk-margin-top'>{{ $t('public.gateway') }}</div>
            <div>
              <div v-for='(item, index) in equiList.gatewayList' :key='index'>
                <div class='uk-flex uk-flex-between uk-margin-small-top'>
                  <div>
                                        <span><i v-if="item.deviceStatus !== 'undefined'"
                                                 :class='equiStatusConvert(item.deviceStatus).icon'
                                                 :title='equiStatusConvert(item.deviceStatus).title'></i></span>
                    <span class='uk-margin-small-left' :class="{ 'higher-range': item.locate }">
                                            {{ item.carrierDeviceName }}</span>
                  </div>
                  <div>
                    <i class='el-icon-tickets cursor-pointer' :title="$t('public.details')"
                       @click='toDetail(item)'></i>
                    <i class='el-icon-location-outline cursor-pointer' :title="$t('public.location')"
                       v-show='!item.locate' @click="locate(item, 'gateway')"></i>
                    <i class='el-icon-close cursor-pointer' :title="$t('integration.cancel')"
                       v-show='item.locate' @click='cancel(item)'></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if='equiList && equiList.displayList.length'>
            <div class='uk-margin-top'>{{ $t('public.display') }}</div>
            <div>
              <div v-for='(item, index) in equiList.displayList' :key='index'>
                <div class='uk-flex uk-flex-between uk-margin-small-top'>
                  <div>
                                        <span><i v-if="item.deviceStatus !== 'undefined'"
                                                 :class='equiStatusConvert(item.deviceStatus).icon'
                                                 :title='equiStatusConvert(item.deviceStatus).title'></i></span>
                    <span class='uk-margin-small-left' :class="{ 'higher-range': item.locate }">{{
                        item.carrierDeviceName }}</span>
                  </div>
                  <div>
                    <i class='el-icon-tickets cursor-pointer' :title="$t('public.details')"
                       @click='toDetail(item)'></i>
                    <i class='el-icon-location-outline cursor-pointer' :title="$t('public.location')"
                       @click="locate(item, 'display')" v-show='!item.locate'></i>
                    <i class='el-icon-close cursor-pointer' :title="$t('integration.cancel')"
                       v-show='item.locate' @click='cancel(item)'></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if='equiList && equiList.relayList.length'>
            <div class='uk-margin-top'>{{ $t('public.relay') }}</div>
            <div v-for='(item, index) in equiList.relayList' :key='index'>
              <div class='uk-flex uk-flex-between uk-margin-small-top'>
                <div>
                                    <span><i :class='equiStatusConvert(item.deviceStatus).icon'
                                             :title='equiStatusConvert(item.deviceStatus).title'
                                             v-if="item.deviceStatus !== 'undefined'"></i></span>
                  <span class='uk-margin-small-left' :class="{ 'higher-range': item.locate }">{{
                      item.carrierDeviceName
                    }}</span>
                </div>
                <div>
                  <i class='el-icon-tickets cursor-pointer' :title="$t('public.details')"
                     @click='toDetail(item)'></i>
                  <i class='el-icon-location-outline cursor-pointer' :title="$t('public.location')"
                     @click="locate(item, 'relay')" v-show='!item.locate'></i>
                  <i class='el-icon-close cursor-pointer' :title="$t('integration.cancel')"
                     v-show='item.locate' @click='cancel(item)'></i>
                </div>
              </div>
            </div>
          </div>

          <el-button type='primary' class='width-100 uk-margin-top uk-margin-bottom' @click='savePoint'>{{
              $t('public.save') }}
          </el-button>
        </div>
        <div style='width: 100%; height: 100%'>
          <canvas id='canvas' width='700px' height='500'></canvas>
        </div>
      </div>
      <equiDetail v-if='detailShow' :detailShow.sync='detailShow' :info='curItem'></equiDetail>
    </div>
  </modal>
</template>

<script>
import { getInstance } from '@/utils/planUtil.js'
import { equiStatusConvert, isAbnormalConvert } from '@/utils/convert'
import { savePosition, uploadCarrierImg } from '@/api/modules/carrier.js'
import equiDetail from './equiDetail.vue'

export default {
  props: ['show', 'carrierImg', 'detail', 'equiPoint'],
  components: {
    equiDetail
  },
  data () {
    return {
      // 记录设备类型
      equiType: 1,
      equiStatusConvert,
      isAbnormalConvert,
      pmNewObj: null,
      myCanvas: null,
      canvasCtx: null,
      zoomRate: 0,
      fileList: [],
      planModule: null,
      curZoom: 1,
      showDialog: true,
      // 当前需要定位的设备
      curItem: null,
      // 当前需要定位的设备类型
      curType: null,
      // canvas中的设备点集
      points: [],
      // 保存当前的图片文件对象
      curFile: '',

      // 设备列表 也就是在左边显示的数据
      equiList: {
        sensorList: [],
        gatewayList: [],
        displayList: [],
        relayList: [],
        baseList: []
      },
      // 编辑模式是否开启
      edit: false,
      newImg: null,
      detailShow: false
    }
  },
  watch: {
    // 用户调整放大缩小比例
    zoomRate (value) {
      if (value < 0) {
        // 缩小
        this.planModule.zoomOut(Math.abs(value))
      } else if (value > 0) {
        // 放大
        this.planModule.zoomIn(value)
      } else {
        this.planModule.zoomIn(value)
      }
    }
  },
  methods: {
    toDetail (item) {
      // 点击详细
      this.curItem = item
      this.detailShow = true
    },
    // 格式化tooltip
    formatTooltip (val) {
      switch (val) {
        case -2:
          return $t('integration.three_times_smaller')
        case -1:
          return $t('integration.shrink_twice')
        case 0:
          return $t('integration.original_proportion')
        case 1:
          return $t('integration.zoom_in_twice')
        case 2:
          return $t('integration.zoom_in_three_times')
      }
    },
    initCanvas () {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          this.myCanvas = document.querySelector('#canvas')
          this.canvasCtx = this.myCanvas.getContext('2d')
          // this.myCanvas.height = this.$refs['pmRight'].offsetHeight - 20
          this.myCanvas.width = this.$refs.pmRight.offsetWidth - 304
          // 使用老版本的类
          // this.Img = this.myCanvas.createImage()
          // this.Img.src = this.pmNewObj['base64Path'];
          this.initParam(this.Img, 0, 0).then(canvas => {
            resolve(canvas)
          })
        })
      })
    },
    // 绘制画布
    initParam (Img, x = 100, y = 100) {
      const that = this
      return new Promise((resolve, reject) => {
        // that.clearRect()
        // that.canvasCtx.beginPath()
        // Img.onload = function () {
        //     console.log(x, y);
        //     that.canvasCtx.drawImage(Img, x, y)
        // }
        let isDrag = false
        const location = [null, null]
        that.$nextTick(() => {
          that.planModule = getInstance({
            id: 'canvas',
            move: true, // 是否可移动
            mousedown: (...args) => {
              isDrag = false
              const event = args[4]
              location[0] = event.offsetX
              location[1] = event.offsetY
            },
            mouseup: (img, down, drop, data, x, y, pos, event) => {
              // 如果移动距离过长 则判定未拖拽 拖拽直接返回
              if (Math.abs(event.offsetX - location[0]) > 20 || Math.abs(event.offsetY - location[1]) > 20) {
                return
              }
              if (!this.curItem) {
                this.$message.warning($t('integration.please_select_the_device_to_be_located'))
                return
              }

              this.curItem.xpos = x
              this.curItem.ypos = y
              this.drawPoint(this.curType, this.curItem)
            }
          })
          // base64赋值到画布
          this.initImage()

          // 如果存在锚点
          if (this.points && this.points.length) {
            this.drawAnchor(this.points)
          }

          resolve(that.planModule)
        })
      })
    },
    initImage () {
      this.planModule.draw([], this.newImg || this.carrierImg)
    },
    // 上传图片前的限制
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return isLt2M
    },
    close () {
      this.$emit('update:show', false)
    },
    // 绘制所有锚点
    drawAnchor (equiPoint) {
      // this.planModule.setData([], true, true)
      this.planModule.setData(equiPoint, true, true, {
        nameParam: 'carrier_device_name',
        statusParam: 'abnormal',
        carrierTypeParam: 'device_catalog'
      })
      // this.planModule.drawImg();
    },
    // 在平面图上绘制一个点
    drawPoint (type, item) {
      let flag = false
      // this.points.map((item)=>{
      //     if(item===this.curItem){
      //         flag=true
      //         return this.curItem;
      //     }
      // })
      // console.log(this.points);
      if (this.points instanceof Array) {
        for (let i = 0; i < this.points.length; i++) {
          const item = this.points[i]

          if (item.carrierDeviceId === this.curItem.carrierDeviceId && item.deviceCatalog === this.curItem.deviceCatalog) {
            flag = true
            this.points[i] = this.curItem

            break
          }
        }
      }

      if (!flag) {
        item.type = type
        this.points.push(item)
      }

      this.planModule.setData(this.points, true, false, {
        nameParam: 'carrier_device_name',
        statusParam: 'abnormal',
        carrierTypeParam: 'device_catalog'
      })
      // that.planModule.drawImg('name', 'status')
    },
    // 在平面图中定位
    locate (item, type) {
      // 如果未上传图片
      if (!this.carrierImg && !this.newImg) {
        this.$message.warning($t('integration.please_upload_the_picture_before_positioning'))
        return
      }
      if (this.curItem) this.curItem.locate = false

      this.curItem = item
      this.curType = item.deviceCatalog
      // 定位标识  标识当前

      this.$set(item, 'locate', true)

      // item.locate = true;
    },
    // 保存点集合 提交到服务器
    savePoint () {
      const type = this.detail.carrierType.id
      const id = this.detail.id
      // const posi = {
      //     sensorPositionList: [],
      //     gatewayPositionList: [],
      //     displayPositionList: [],
      //     relayPositionList: []
      // };
      // 以点的eqtype字段来区分类型  分别添加到不同的数组
      const deviceAnchors = []
      this.points.forEach(item => {
        if (item.xpos === undefined || item.ypos === undefined) {
          return
        }
        deviceAnchors.push({
          carrier_id: id,
          carrier_device_id: item.carrierDeviceId,
          xpos: item.xpos,
          ypos: item.ypos
        })
      })

      savePosition(type, id, deviceAnchors).then(({ result }) => {
        if (result) {
          this.$message({
            type: 'success',
            message: $t('integration.saved_successfully')
          })
          this.curItem.locate = false
          this.curItem = null
          this.$emit('update:equiPoint', this.points)
        }
      })
    },
    // 上传图片
    uploadImg (file) {
      const type = this.detail.typeId

      if (!this.detail.typeId) return this.$message.error('出错了！')
      const fd = new FormData()
      fd.append('uploadFile', file.file)
      fd.append('carrierId', this.detail.id)

      uploadCarrierImg(type, fd).then(({ result }) => {
        // 兼容 MinIO 模式（result 为 URL 字符串）和本地模式（result 为对象 { state, base64File }）
        const imgUrl = typeof result === 'string' ? result : (result.base64File || result.path)
        if (imgUrl) {
          this.newImg = imgUrl
          this.$message({
            message: $t('integration.upload_successful'),
            type: 'success'
          })
          // 图片回显
          this.$emit('update:carrierImg', this.newImg)
          this.points = []
          this.$emit('update:equiPoint', this.points)
          this.initCanvas().then(canvas => {
          })
        }
      })

      return Promise.resolve()
    },
    fileChange (e) {
      this.curFile = e
    },
    submitUpload () {
      this.$confirm($t('integration.this_operation_will_remove_all_monitoring_point_anchors_dot__are_you_sure_this_operation_q'))
        .then(() => {
          this.$refs.upload.submit()
        })
        .catch(() => {
        })
    },
    cancel (item) {
      item.locate = false
      this.curItem = null
    }
  },
  mounted () {
    // 深拷贝是因为可能在锚点过程中会间接修改到锚点的坐标 为了先不影响到父级
    // this.equiList = JSON.parse(JSON.stringify(this.detail.carrierDevice.deviceList));
    this.detail.carrierDevice.deviceList.forEach(item => {
      item = JSON.parse(JSON.stringify(item))

      switch (parseInt(item.deviceCatalog)) {
        case 0:
          this.equiList.sensorList.push(item)
          break
        case 1:
          this.equiList.gatewayList.push(item)
          break
        case 2:
          this.equiList.displayList.push(item)
          break
        case 3:
          this.equiList.relayList.push(item)
          break
        case 4:
          this.equiList.baseList.push(item)
          break
      }
    })
    this.points = JSON.parse(JSON.stringify(this.equiPoint))
    this.initCanvas().then(canvas => {
      // 图标首次渲染出不来？？？Iconfont没加载完还是咋的 暂时这样解决吧
      setTimeout(() => {
        this.planModule.zoomIn(0)
        setTimeout(() => {
          this.planModule.zoomIn(0)
        }, 500)
      }, 500)
      // this.drawPoint(this.curType,this.curItem);
    })
  }
}
</script>

<style lang='scss' scoped>
.aside {
  width: 400px;
  border-right: solid lightgray 1px;
  padding: 0 13px;
  overflow-x: hidden;
  overflow-y: auto;
}

::v-deep .el-dialog__body {
  padding: 0px 0px 0 0;
}

::v-deep .el-dialog__footer {
  padding: 0;
}
</style>
